export default __webpack_public_path__ + "static/media/acc-cards-icon.2538bd4d.svg";